import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userLogin } from 'react-admin';

class LoginPage extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.userLogin({});
    }

    render() {
        return (
            <div></div>
        );
    }
};

export default connect(undefined, { userLogin })(LoginPage);